import { 
    BW_HEADER, 
    SELECTED_TOUR_TEMPLATE,
    CONTACT_INFO_FIELDS,
    FOOTER_LOGO,
    ERROR_MESSAGE,
    LINK_EMAIL,
    LINK_PHONE,
    MOBILE_SUBMIT_BAR,
    ICON_LOCK,
    FOOD_PREF_POPUP_CONTAINER
} from 'booking-widget/v2/templates/shared';

export const TC_AGREE_CHECKBOXES = `
<label class="bw-highlight--checkbox bw-mb--30" style="display: inline-block;">
    <input type="checkbox" name="tc_agree" value="1" class="bw-mr--05em" oninvalid="this.setCustomValidity(\'This is required to proceed.\')" oninput="this.setCustomValidity(\'\')" required />I agree to the terms and conditions listed above.
</label>
`;
export const PAYMENT_TEMPLATE = `
<div class="bw bw-payment">
    ${BW_HEADER}
    <div class="bw-title bw-desktop-only-block bw-mb--md-37">
        <h1 class="bw-text-center bw-mb--0">Secure Payment <span class="bw-gc-hide">&amp; Terms</span></h1>
    </div>
    <div class="bw-body">
        ${SELECTED_TOUR_TEMPLATE}
        <div class="bw-form-wrap">
            ${ERROR_MESSAGE}
            <form class="bw-form" action="" autocomplete="on">
                <h2 class="bw-mt--10 bw-contact-info-field"><span class="bw-gc-hide">Primary</span> Contact Info</h2>
                ${CONTACT_INFO_FIELDS}
                <div class="bw-form--payment">
                    <h2 class="bw-mt--8 bw-mt--md-30">Secure Payment</h2>
                    <div class="bw-row bw-red payment-error-message" style="display:none"></div>
                    <div class="bw-row">
                        <label for="cc_number" class="bw-sr">Card Number</label>
                        <input placeholder="*XXXX XXXX XXXX XXXX" type="text" id="cc_number" name="cc_number" autocomplete="cc-number" value="" required>
                    </div>
                    <div class="bw-row--flex-row">
                        <div class="bw-flex-basis-66">
                            <label for="cc_exp" class="bw-sr">Expiration (MM/YY)</label>
                            <input type="text" id="cc_exp" name="cc_exp" placeholder="*Expiration (MM/YY)" data-target="cc-exp" required>
                        </div>
                        <div class="bw-flex-basis-33">
                            <label for="cvv_code" class="bw-sr">CVV</label>
                            <input type="text" id="cvv_code" name="cc_cvv" placeholder="*CVV" data-target="cc-cvv" maxlength="4" required>
                        </div>
                    </div>
                    <div class="bw-row--flex-row">
                        <div class="bw-flex-basis-66">
                            <label class="bw-sr" for="cc_name">*Name on Card</label>
                            <input type="text" id="cc_name" name="cc_name" placeholder="*Name on Card" data-target="cc-name" required>
                        </div>
                        <div class="bw-flex-basis-33">
                            <label for="billing_zip_code" class="bw-sr">Zip Code</label>
                            <input type="text" id="billing_zip_code" name="billing_zip_code" placeholder="*Zip code" data-target="billing-zip-code" required>
                        </div>
                    </div>
                </div>

                <div class="bw-gc-hide">
                    <a class="bw-terms-link showing bw-mobile-only" href="#">By clicking "Make Payment" to complete your booking, you're agreeing to Capt Andy's <span style="text-decoration:underline;">terms &amp; conditions</span> <span class="bw-icon--chevron-up"></span><span class="bw-icon--chevron-down"></span></a>
                </div>

                <div class="bw-desktop-only">
                    <div class="bw-payment-secure-text bw-mb--20">
                        ${ICON_LOCK} Payments are secure.
                    </div>
                    <div class="bw-gc-hide bw-mb--10">
                        <a class="bw-terms-link showing bw-fsxd--16" href="#">By clicking "Complete Booking" to make your reservation, you're agreeing to Capt Andy's <span style="text-decoration:underline;">terms &amp; conditions</span> <span class="bw-icon--chevron-up"></span><span class="bw-icon--chevron-down"></span></a>
                    </div>
                </div>
                
                <div class="bw-terms-conditions bw-gc-hide" style="display:none;"></div>

                <div class="bw-payment-secure-text bw-mobile-only">
                    ${ICON_LOCK} Payments are secure.
                </div>

                <input type="hidden" id="cardholder_name">
                <input type="hidden" id="exp_month">
                <input type="hidden" id="exp_year">
                <input type="submit" class="bw-button bw-form-submit bw-desktop-only" data-original="Continue to Payment" value="Complete Booking">
            </form>
        </div>
    </div>
    <div class="bw-footer bw-desktop-only-flex">
        ${FOOTER_LOGO}
    </div>
    ${MOBILE_SUBMIT_BAR}
</div>
${FOOD_PREF_POPUP_CONTAINER}
`;

export const PAYMENT_ERROR_RES_SUCCESS = `Your payment has gone through, but your reservation is still pending.  Please email ${LINK_EMAIL} or call ${LINK_PHONE} with your reservation number: `;


export const PAYMENT_ERROR_GENERIC = `Your payment could not be processed.  Please ensure all information is correct and try again.`;